import { render, staticRenderFns } from "./AverageChart.vue?vue&type=template&id=d0bc9808&"
import script from "./AverageChart.vue?vue&type=script&lang=js&"
export * from "./AverageChart.vue?vue&type=script&lang=js&"
import style0 from "./AverageChart.vue?vue&type=style&index=0&id=d0bc9808&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports